export type M365ClientSecretExpiry = {
  available: boolean;
  reason?: string;
  message?: string;
  matched?: boolean;
  using_soonest?: boolean;
  expired?: boolean;
  expires_at?: string;
  days_remaining?: number;
  display_name?: string | null;
  secret_count?: number;
};

const WARNING_DAYS = 30;

export function formatM365ExpiryDate(iso?: string): string {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
}

export function formatM365ClientSecretExpiryCaption(
  expiry: M365ClientSecretExpiry | null | undefined
): string {
  if (!expiry) return "";
  if (!expiry.available) {
    return String(expiry.message || "").trim();
  }
  const dateLabel = formatM365ExpiryDate(expiry.expires_at);
  const days = Number(expiry.days_remaining);
  const name = expiry.display_name ? `“${expiry.display_name}” ` : "";
  if (expiry.expired) {
    return `${name}Expired ${dateLabel}`.trim();
  }
  const daysLabel = Number.isFinite(days)
    ? `${days} day${days === 1 ? "" : "s"} left`
    : "";
  const prefix =
    expiry.using_soonest && !expiry.matched && Number(expiry.secret_count) > 1
      ? "Soonest secret on this app expires"
      : `${name}Expires`.trim();
  return `${prefix} ${dateLabel}${daysLabel ? ` · ${daysLabel}` : ""}`.trim();
}

export function m365ClientSecretExpiryTone(
  expiry: M365ClientSecretExpiry | null | undefined
): "error" | "warning" | "neutral" {
  if (!expiry?.available) return "neutral";
  if (expiry.expired) return "error";
  if (Number(expiry.days_remaining) <= WARNING_DAYS) return "warning";
  return "neutral";
}

/** Short pill text for the Client Secret field. Null when there is nothing to show on the box. */
export function formatM365ClientSecretExpiryChipLabel(
  expiry: M365ClientSecretExpiry | null | undefined
): string | null {
  if (!expiry?.available) return null;
  if (expiry.expired) return "Expired";
  const days = Number(expiry.days_remaining);
  if (Number.isFinite(days) && days <= WARNING_DAYS) {
    return `Expires in ${days} day${days === 1 ? "" : "s"}`;
  }
  const dateLabel = formatM365ExpiryDate(expiry.expires_at);
  return dateLabel ? `Expires ${dateLabel}` : null;
}
